

import { Component, Vue } from 'vue-property-decorator'
import BeaconModel from '@/_models/BeaconModel'
import { Filter } from '@/_utils/filter'

// Interfaces
import { IPageFilterModel } from '@/_interfaces'

@Component({
  components: {},
  computed: {},
})
export default class BeaconListMixin extends Vue {
  canEdit!: () => boolean
  canDelete!: () => boolean

  // data
  filterUtilPage: any = new Filter('filter_beaconlist_page')
  pageFilters: IPageFilterModel = {
    currentPage: 1,
    perPage: 10,
    selectedFilter: 'major',
    searchQuery: '',
    activeTab: 0, // 0: floor, 1: geofence
  }

  numofPage: number = 1
  selected: BeaconModel = new BeaconModel()
  isFormModalActive: boolean = false
  isSearchUserActive: boolean = false
  isImportCsvModalActive: boolean = false

  isNew: boolean = false

  beaconType!: string

  // Import/Export csv setting
  csvFile: any = null
  csvFields: any = []

  filedNameLUT: any = {
    _id: 'UUID',
    beacon_uuid: 'label.beacon_uuid',
    user_name: 'label.username',
    user_id: 'label.user_id',
    category_name: 'label.category_name',
    location_name: 'label.possition',
    major: 'label.major',
    minor: 'label.minor',
    lon: 'label.lon',
    lat: 'label.lat',
    floor_name: 'label.floor',
    floor_id: 'label.floor_id',
  }

  // computed
  get beacons(): BeaconModel[] {
    const beacons = this.$store.state.beacons.all.items
    if (!beacons.length) {
      return []
    }
    const beaconsByType = beacons.filter((bc: BeaconModel) => {
      return bc.beacon_type === this.beaconType
    })

    this.numofPage = Math.ceil(beaconsByType.length / this.pageFilters.perPage)

    return beaconsByType
  }

  get allBeacons(): BeaconModel[] {
    return this.$store.state.beacons.all.items
  }

  get labelBeaconUUID(): string {
    return this.$t('label.beacon_uuid') as string
  }

  get selectedUser(): object {
    return {
      _id: this.selected.user_id,
      name: this.selected.user_name,
    }
  }

  get buttonSaveText(): any {
    return this.isNew ? this.$t('button.register') : this.$t('button.save')
  }

  get isLoading(): boolean {
    return this.$store.state.beacons.loading
  }

  get filteredData(): BeaconModel[] {
    const targetField: string = this.pageFilters.selectedFilter
    if (!this.beacons) {
      return []
    }

    return this.beacons.filter((item: any): boolean => {
      return (
        String(item[targetField]).toLowerCase().indexOf(this.pageFilters.searchQuery.toLowerCase()) !== -1
      )
    })
  }

  get filteredDataBeaconUUID(): BeaconModel[] {
    if (!this.beacons) {
      return []
    }

    const beacons = this.beacons.filter((item: any): boolean => {
      return String(item.beacon_uuid).toLowerCase().indexOf(this.selected.beacon_uuid.toLowerCase()) !== -1
    })

    return beacons.slice(0, 5)
  }

  get isValidLocation() {
    return !this.selected.floor_id
  }

  created() {
    this.$validator.extend('customUniqueMajorMinor', this.isUniqueMajorMinor)
    this.getAllBeacons()
  }

  // Declare here, should implement in Component
  getAllBeacons(): void {
    return
  }

  isUniqueMajorMinor(value): boolean {
    for (const beacon of this.allBeacons) {
      if (this.isNew) {
        if (beacon.major === this.selected.major && beacon.minor === this.selected.minor) {
          return false
        }
      } else {
        if (
          beacon.major === this.selected.major &&
          beacon.minor === this.selected.minor &&
          beacon._id !== this.selected._id
        ) {
          return false
        }
      }
    }

    return true
  }

  handleOpenModalEdit(data): void {
    this.isFormModalActive = true
    this.selected = Object.assign({}, data)
    this.isNew = false
  }

  handleOpenModalAdd(): void {
    this.isFormModalActive = true
    this.selected = new BeaconModel()
    this.isNew = true
  }

  handleSelecteBeaconUUID(item: BeaconModel): void {
    this.selected.beacon_uuid = item.beacon_uuid
  }

  handleOpenModalImportCSV(): void {
    this.isImportCsvModalActive = true
  }

  handleCancelImportModal(): void {
    this.isImportCsvModalActive = false
    this.csvFile = null
  }

  // methods
  convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  selectedUserDone(data): void {
    this.selected.user_id = data._id
    this.selected.user_name = data.name
    this.selected.category_name = data.category_name
    this.isSearchUserActive = false
  }

  beforeDestroy() {
    this.filterUtilPage.save(this.pageFilters)
  }

  async handleApplyChange(): Promise<void> {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return false
      }
      if (this.$refs.beaconRef && !(this.$refs as any).beaconRef.submit()) {
        return false
      }
      if (this.isNew) {
        // add item
        this.$store.dispatch('beacons/addOne', this.selected).then(resp => {
          this.isFormModalActive = false
          this.$buefy.toast.open(this.$t('messages.save_success') as string)
        })
      } else {
        // update item
        this.$store.dispatch('beacons/updateOne', this.selected).then(resp => {
          this.isFormModalActive = false
          this.$buefy.toast.open(this.$t('messages.update_success') as string)
        })
      }
    })
  }

  confirmCustomDelete(data): void {
    this.selected = data

    this.$buefy.dialog.confirm({
      title: this.$t('delete') as string,
      message: this.$t('messages.are_you_sure_want_to_delete') as string,
      confirmText: this.$t('delete') as string,
      cancelText: this.$t('button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        // Delete row
        const index = this.beacons.indexOf(this.selected)
        await this.$store.dispatch('beacons/deleteOne', this.selected)
        this.selected = new BeaconModel()
        this.$buefy.toast.open(this.$t('messages.delete_success') as string)
      },
    })
  }

  async handleImportCSV(params): Promise<void> {
    this.$store.dispatch('beacons/importCSV', { file: this.csvFile, params }).then(resp => {
      this.handleCancelImportModal()
      this.$buefy.toast.open(this.$t('messages.save_success') as string)
    })
  }
}
